import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UrlRankResult, UrlRankError } from '../Model/UrlRank';

interface UrlRankState {
  loading: boolean;
  /** pending/running 중간 상태 포함 */
  result: UrlRankResult | null;
  error: UrlRankError | null;
}

const initialState: UrlRankState = {
  loading: false,
  result: null,
  error: null,
};

const urlRankSlice = createSlice({
  name: 'urlRank',
  initialState,
  reducers: {
    setUrlRankLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUrlRankProgress: (state, action: PayloadAction<UrlRankResult>) => {
      state.loading = true;
      state.result = action.payload;
      state.error = null;
    },
    setUrlRankResult: (state, action: PayloadAction<UrlRankResult>) => {
      state.loading = false;
      state.result = action.payload;
      state.error = null;
    },
    setUrlRankError: (state, action: PayloadAction<UrlRankError>) => {
      state.loading = false;
      state.error = action.payload;
      state.result = null;
    },
    clearUrlRankState: (state) => {
      state.loading = false;
      state.result = null;
      state.error = null;
    },
  },
});

export const {
  setUrlRankLoading,
  setUrlRankProgress,
  setUrlRankResult,
  setUrlRankError,
  clearUrlRankState,
} = urlRankSlice.actions;

export default urlRankSlice.reducer;
